module.exports = __webpack_public_path__ + "img/9788984318311.1d2aeace.jpg";